<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="copyright"><a id="page_vi"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="copyright"><span class="small">RIVAL TO THE QUEEN.</span> Copyright © 2010 by Carolly Erickson. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="copyrighta"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="copyrighta">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Erickson, Carolly, 1943–</p>
<p class="copyright1">Rival to the queen / Carolly Erickson. — 1st ed.</p>
<p class="copyright2">p. cm.</p>
<p class="copyright1">ISBN 978-0-312-37974-2</p>
<p class="copyright1">1. Leicester, Lettice Dudley, Countess of, 1543–1634—Fiction. 2. Elizabeth I, Queen of England, 1533–1603—Fiction. 3. Leicester, Robert Dudley, earl of, 1532?–1588—Fiction. 4. Nobility—Great Britain—Fiction. 5. Queens—Great Britain—Fiction. I. Title.</p>
<p class="copyright1">PS3605.R53R58 2010</p>
<p class="copyright1">813'.6—dc22</p>
<p class="right-paraa">2010025197</p>
<p class="copyrighta">First Edition: October 2010</p>
<p class="copyrighta">10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?d8443b02